"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuery = require("react-query");

var _hooks = require("@nicbase/hooks");

var _request = require("@nicbase/request");

var _nicbaseBasicTable = require("nicbase-basic-table");

var _nicbaseFilters = require("nicbase-filters");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _tourInfoBlock = _interopRequireDefault(require("./tour-info-block/tour-info-block"));

var _waypointTimeline = _interopRequireDefault(require("./waypoint-timeline"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var findLatestData = function findLatestData(widgetId, dynamicFilters, portalId) {
  return {
    type: 'FIND_LATESTDATA_REQUEST',
    headers: {
      version: 'v1',
      widgetId: widgetId,
      portalId: portalId
    },
    body: {
      dynamicFilters: dynamicFilters,
      dynamicSorters: null,
      dynamicPaging: null
    }
  };
};

var RowRenderer = function RowRenderer(_ref) {
  var cellCache = _ref.cellCache,
      parent = _ref.parent,
      index = _ref.index,
      onRowClick = _ref.onRowClick,
      rowData = _ref.rowData,
      className = _ref.className,
      columns = _ref.columns,
      isSelected = _ref.isSelected,
      style = _ref.style;
  var updateRowSize = (0, _react.useCallback)(function () {
    cellCache.clear(index);
    parent.recomputeGridSize({
      rowIndex: index
    });
  }, [cellCache, index, parent]); // update row size and scroll to row if it gets selected

  (0, _hooks.useDidUpdate)(function () {
    if (isSelected) {
      updateRowSize();
      parent.scrollToCell({
        rowIndex: index
      });
    }
  }, [index, isSelected, parent, updateRowSize]); // update row size if the columns have changed

  (0, _react.useLayoutEffect)(function () {
    updateRowSize();
  }, [columns, updateRowSize]);

  var _useWidget = (0, _nicbaseReducers.useWidget)(),
      widgetId = _useWidget.id;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _useQuery = (0, _reactQuery.useQuery)(['latestData', {
    portalId: portalId,
    widgetId: widgetId,
    assetId: rowData.assetId
  }], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _and, filterTree, _yield$request, _yield$request$body$l, latestDataAsset;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _and = (0, _nicbaseFilters.and)((0, _nicbaseFilters.equal)('latestData.assetId', rowData.assetId, 'Integer')), filterTree = _and.filterTree;
            _context.prev = 1;
            _context.next = 4;
            return request(findLatestData(widgetId, filterTree, portalId));

          case 4:
            _yield$request = _context.sent;
            _yield$request$body$l = _slicedToArray(_yield$request.body.latestData, 1);
            latestDataAsset = _yield$request$body$l[0];
            return _context.abrupt("return", latestDataAsset);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", undefined);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  })), {
    enabled: !!isSelected && !!rowData.assetId,
    refetchInterval: 60000
  }),
      latestData = _useQuery.data;

  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "row",
    key: rowData.id,
    className: className,
    style: Object.assign({}, style, {
      flexDirection: 'column'
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex",
    onClick: function onClick() {
      onRowClick({
        index: index,
        rowData: rowData
      });
    }
  }, columns.map(function (column, columnIndex) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseBasicTable.ColumnRenderer, {
      key: "".concat(rowData.id, "-").concat(column.props.dataKey),
      column: column,
      cellCache: cellCache,
      columnIndex: columnIndex,
      parent: parent,
      rowData: rowData,
      rowIndex: index,
      scrollbarWidth: style.scrollbarWidth
    });
  })), isSelected ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex flex-col p-2 bg-white"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-1 mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_waypointTimeline["default"], {
    waypoints: rowData.wayPoints,
    assetType: rowData.assetType,
    status: rowData.status,
    realStartTime: rowData.realStartTime,
    latestData: latestData
  }), /*#__PURE__*/_react["default"].createElement(_tourInfoBlock["default"], {
    tour: rowData,
    latestData: latestData
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.row.expandLess"
  }, function (title) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "inline-block",
      title: title,
      role: "button",
      tabIndex: 0,
      onClick: function onClick() {
        onRowClick({
          index: index,
          rowData: rowData
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ExpandLess, {
      className: "h-6 w-6 fill-primary"
    }));
  }))) : null);
};

RowRenderer.propTypes = _nicbaseBasicTable.RowRenderer.propTypes;
RowRenderer.defaultProps = _nicbaseBasicTable.RowRenderer.defaultProps;
var _default = RowRenderer;
exports["default"] = _default;